export interface Einheit {
  id: number;
  arteh: string;
}
